module.exports = __webpack_public_path__ + "img/oostenrijk1.0b90d6fa.jpg";